export default __webpack_public_path__ + "static/media/Image1.62dc4512.jpg";